var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1562 22.5109C12.1562 23.0224 12.3594 23.5129 12.7211 23.8746C13.0828 24.2363 13.5733 24.4395 14.0848 24.4395C14.5963 24.4395 15.0868 24.2363 15.4485 23.8746C15.8102 23.5129 16.0134 23.0224 16.0134 22.5109C16.0134 21.9994 15.8102 21.5089 15.4485 21.1472C15.0868 20.7855 14.5963 20.5823 14.0848 20.5823C13.5733 20.5823 13.0828 20.7855 12.7211 21.1472C12.3594 21.5089 12.1562 21.9994 12.1562 22.5109ZM13.1205 17.4484H15.0491C15.1817 17.4484 15.2902 17.3399 15.2902 17.2073V3.2252C15.2902 3.09261 15.1817 2.98413 15.0491 2.98413H13.1205C12.9879 2.98413 12.8795 3.09261 12.8795 3.2252V17.2073C12.8795 17.3399 12.9879 17.4484 13.1205 17.4484Z",
    fill: "#130F26",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/Exclamation.462a1b149467f12a1c54f56dba054807.svg";
export { ForwardRef as ReactComponent };